
import {
  ref, onMounted, watch, reactive, onUnmounted, nextTick, defineComponent,
} from 'vue';
import * as echarts from 'echarts';
import moment from 'moment';
import html2canvas from 'html2canvas';
import { downLoad, } from '@/utils/index';

export default defineComponent({
  components: {},
  props: {
    timeFormat: {
      type: String,
      default: () => '',
      require: true,
    },
    airType: {
      type: String,
      default: () => '',
      require: true,
    },
    listData: {
      type: Array,
      default: () => [],
      require: true,
    },
    isDownloadChart: {
      type: Boolean,
      default: () => false,
      require: true,
    },
  },
  setup (props, { emit, }) {
  interface chartOption {
    legend: any;
    xAxis: any;
    yAxis: any;
    series: any;
    tooltip: any;
    dataZoom?: any;
    visualMap?: any;
  }

  // 要素对应文字
  const factorKey = {
    pm25: '<span>PM<sub>2.5</sub></span>',
    pm10: '<span>PM<sub>10</sub></span>',
    so2: '<span>SO<sub>2</sub></span>',
    no2: '<span>NO<sub>2</sub></span>',
    co: 'CO',
    o3: '<span>O<sub>3</sub></span>',
    aqi: 'AQI',
    tvoc: 'TVOC',
  };

  // 图表symbol
  const allSymbol = [
    'circle',
    'emptyCircle',
    'rect',
    'diamond',
    'triangle',
  ];

  // 折线图配置项
  const option: chartOption = reactive({
    legend: {
      type: 'scroll',
      orient: 'vertical',
      right: '0%',
      top: 'middle',
      itemWidth: 25,
      itemHeight: 10,
      textStyle: {
        fontSize: 18,
        fontWeight: 400,
        fontFamily: 'Microsoft YaHei',
        // 主标题文字颜色
        color: 'rgba(0,0,0,0.8)',
      },
    },
    grid: {
      right: '12%',
    },
    xAxis: {
      type: 'category',
      axisLabel: {
        inside: false,
        textStyle: {
          color: '#000',
          fontSize: '16',
          itemSize: '',
        },
      },
      axisTick: {
        show: false,
      },
      axisPointer: {
        show: true,
        type: 'shadow',
        label: {
          show: false,
        },
      },
    },
    yAxis: {
      name: '',
      nameTextStyle: {
        fontSize: 16,
        // 四个数字分别为上右下左与原位置距离
        padding: [
          0,
          0,
          40,
          0,
        ],
      },
      nameLocation: 'center',
      type: 'value',
      axisLabel: {
        inside: false,
        textStyle: {
          color: '#000',
          fontSize: '16',
          itemSize: '',
        },
      },
    },

    /*
     * visualMap: {
     *   top: 50,
     *   right: 10,
     *   pieces: [],
     *   outOfRange: {
     *     color: '#999',
     *   },
     * },
     */
    dataZoom: [
      {
        type: 'inside',
        start: 0,
        end: 100,
      },
      {
        start: 0,
        end: 100,
      },
    ],
    series: [],
    tooltip: {
      show: true,
      formatter: (param: any) => `<div
                      style="
                        padding: 0.15rem;
                        border-radius: 0.04rem;
                        font-size: 0.14rem;
                        font-weight: 400;
                      "
                    >
                      <div><span>${param[0]?.name}</span></div>
                      ${
  param.map((cur:any) => `<div style="display: flex;"><span style="flex: 2;">${cur.seriesName}</span>&nbsp&nbsp&nbsp&nbsp<span style="flex: 3; text-align: left;">${cur.value ?
    cur.value :
    '--'}${cur.data.valueUnit}</span></div>`)
    .join('')
}
                    </div>`,
      textStyle: {
        align: 'left',
        fontSize: '16',
      },
      axisPointer: {
        type: 'line',
      },
    },
  });

  const listChart = ref<any>(null);
  // echarts容器不应该使用vue3的Proxy对象代理 不仅降低性能还可能找不到内部数据
  let chart:any = null;
  const noDataShow = ref<boolean>(false);
  const cAirType = ref<string>('');

  /**
   *  配置线状图
   * @param {any} val 配置项
   * @return {void}
   */
  const setChart = (val: any) => {
    nextTick(() => {
      if (val && Object.keys(chart).length) {
        // 不和之前的option合并
        chart.setOption(val, true);
      }
    });
  };

  const dealStandardData = (list: any, str: string, isCo:boolean, isAqi:boolean) => {
    const temp: any = [];

    if (str === 'xAxis') {
      Object.keys(list[0]).forEach((item) => {
        if (item !== 'name' && item !== 'type' && item !== 'avg') {
          temp.push(
            moment(item, props.timeFormat).format(props.timeFormat.length === 10 ?
              `${props.timeFormat.slice(-6,-4)}-${props.timeFormat.slice(-4,-2)} ${props.timeFormat.slice(-2)}:mm` :
              props.timeFormat.length === 8 ?
                `${props.timeFormat.slice(-4,-2)}-${props.timeFormat.slice(-2)}` :
                props.timeFormat)
          );
        }
      });
    }

    if (str === 'series') {
      list.forEach((item: any, index: number) => {
        temp.push({
          name: item.name,
          type: 'line',
          smooth: true,
          symbol: allSymbol[index],
          symbolSize: 8,
          data: Object.keys(item).map((cur:any) => ({
            value: cur !== 'name' && cur !== 'type' && cur !== 'avg' && Number(item[cur]) === -9999 ?
              '' :
              item[cur],
            valueUnit: isAqi ?
              '' :
              isCo ?
                'mg/m³' :
                'μg/m³'
            ,
          })),

          /*
           * tooltip: {
           *   show: true,
           *   formatter: (param: any) => {
           *     const {
           *       name, value, data,
           *     } = param;
           *     const { valueUnit, } = data;
           *     return `<div><div style="font-weight:bold;">${name}</div>${value}${valueUnit}</div>`;
           *   },
           *   textStyle: {
           *     align: 'left',
           *     fontSize: '16',
           *   },
           * },
           */
        });
      });
    }

    return temp;
  };

  const drawChart = (data:any):void => {
    option.yAxis.name = props.airType === 'aqi' ?
      '' :
      props.airType === 'co' ?
        '浓度mg/m³' :
        '浓度μg/m³';
    // option.visualMap.pieces = factorColorList(props.airType);
    option.xAxis.data = dealStandardData(data, 'xAxis', props.airType === 'co', props.airType === 'aqi');
    option.series = dealStandardData(data, 'series', props.airType === 'co', props.airType === 'aqi');

    setChart(option);
  };

  /**
   *  重置图表
   * @param {any} val value
   * @return {void}
   */
  const reSize = (): any => {
    if (Object.keys(chart).length) {
      chart.resize();
    }
  };

  /**
   * 初始化图表
   * @returns {void}
   */
  const initCharts = () => {
    chart = echarts.init(listChart.value);
    window.addEventListener('resize', reSize);
  };

  /**
   *  下载图表
   * @return {void}
   */
  const downloadChart = (): any => {
    html2canvas(listChart.value,{
      width: listChart.value.clientWidth,
      height: listChart.value.clientHeight,
      scrollY: 0,
      scrollX: 0,
      scale: 0.8,
      useCORS: true,
      allowTaint: false,
    }).then((canvas) => {
      const base64 = canvas.toDataURL('image/png');

      downLoad(base64,`${factorKey[cAirType.value]}浓度趋势图`);
      emit('hadDownloadChart');
    });
  };

  watch(() => props.listData, (val) => {
    if (val.length) {
      noDataShow.value = false;
      cAirType.value = props.airType;
      drawChart(val);
    } else {
      noDataShow.value = true;
    }
  },{
    deep: true,
    immediate: true,
  });

  watch(() => props.isDownloadChart, (val) => {
    if (val) {
      downloadChart();
    }
  });

  /**
   * 挂载图表
   */
  onMounted(() => {
    initCharts();
  });

  /**
   * 销毁图表
   */
  onUnmounted(() => {
    window.removeEventListener('resize', reSize);

    echarts.dispose(chart);
    chart = null;
  });

  return {
    props,
    factorKey,
    noDataShow,
    listChart,
    cAirType,
    downloadChart,
  };
  },
});
